<template>
  <div class="app-right-main">
    <el-tabs v-model="activeName">
      <el-tab-pane label="发送兑换码" name="one">
        <el-alert
          title="输入邮箱或从Excel复制邮箱到下面文本域；例如：xxx@gmail.com VIP年会员"
          type="info"
          show-icon
          :closable="false"
          style="margin-bottom: 8px"
        >
        </el-alert>

        <el-input
          type="textarea"
          :rows="3"
          v-model="emails"
          clearable
          placeholder="请输入邮箱"
          style="margin-bottom: 8px"
        ></el-input>

        <div style="margin-bottom: 8px">
          <el-tag
            v-for="(v, k) in vipMap"
            :key="k"
            style="margin-right: 5px; cursor: pointer"
            @click="setVip(v.content)"
          >
            {{ v.content }}
          </el-tag>
        </div>

        <el-table
          :data="vipEmails"
          size="small"
          style="width: 100%"
          height="300"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column align="left" prop="key" label="序号" width="100" />
          <el-table-column
            align="left"
            prop="email"
            label="邮箱"
            min-width="150"
          />
          <el-table-column
            align="left"
            prop="vip"
            label="会员内容"
            min-width="150"
          >
            <template slot-scope="scope">
              {{ scope.row.vip?.content }}
            </template>
          </el-table-column>
          <el-table-column
            align="left"
            prop="err"
            label="说明"
            min-width="100"
          />
        </el-table>
        <div style="padding: 10px; text-align: center">
          <el-button
            type="primary"
            icon="el-icon-s-promotion"
            @click="sendCode"
          >
            确认发送
          </el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane label="发送记录" name="two">
        <el-row class="searchRow">
          <el-col :span="22">
            <!-- 查询框区域 -->
            <el-form
              :model="searchForm"
              size="mini"
              :inline="true"
              label-width="90px"
            >
              <el-row :span="24">
                <el-col :span="8">
                  <el-form-item label="搜索" prop="keyword">
                    <el-input
                      v-model="searchForm.keyword"
                      clearable
                      placeholder="请输入兑换码、邮箱"
                      style="width: 14vw"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="会员内容" prop="vip">
                    <el-select
                      v-model="searchForm.vip"
                      placeholder="请选择"
                      clearable
                      style="width: 14vw"
                    >
                      <el-option
                        v-for="(v, k) in vipMap"
                        :key="k"
                        :label="v.content"
                        :value="k"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="发送状态" prop="sendStatus">
                    <el-select
                      v-model="searchForm.sendStatus"
                      placeholder="请选择"
                      clearable
                      style="width: 14vw"
                    >
                      <el-option
                        v-for="(v, k) in sendStatusMap"
                        :key="k"
                        :label="v"
                        :value="k"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="兑换状态" prop="status">
                    <el-select
                      v-model="searchForm.status"
                      placeholder="请选择"
                      clearable
                      style="width: 14vw"
                    >
                      <el-option
                        v-for="(v, k) in statusMap"
                        :key="k"
                        :label="v"
                        :value="k"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="发送时间" prop="createdAt">
                    <el-date-picker
                      clearable
                      v-model="searchForm.createdAt"
                      type="daterange"
                      :value-format="'yyyy-MM-dd'"
                      range-separator="-"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      style="width: 14vw"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="兑换时间" prop="exchangeTime">
                    <el-date-picker
                      clearable
                      v-model="searchForm.exchangeTime"
                      type="daterange"
                      :value-format="'yyyy-MM-dd'"
                      range-separator="-"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      style="width: 14vw"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-col>

          <!-- 提交按钮 -->
          <el-col :span="2" class="searchbuttons">
            <div>
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-search"
                @click="init()"
                >查询</el-button
              >
            </div>
            <div class="searchButton">
              <el-button
                type="info"
                size="mini"
                icon="el-icon-refresh-right"
                @click="reset"
                >重置</el-button
              >
            </div>
          </el-col>
        </el-row>
        <el-row style="margin-bottom: 10px">
          <el-col :span="12">
            <el-tag style="margin-right: 5px">
              总数：{{ totalData.total }}
            </el-tag>
            <el-tag style="margin-right: 5px">
              作废：{{ totalData.zf }}
            </el-tag>
            <el-tag style="margin-right: 5px">
              已兑换：{{ totalData.ydh }}
            </el-tag>
            <el-tag style="margin-right: 5px">
              兑换率：{{ totalData.dhl }} %
            </el-tag>
          </el-col>
          <el-col :span="12" style="text-align: right">
            <el-button
              type="primary"
              icon="el-icon-download"
              size="small"
              @click="download"
              v-permission="'down_redeem'"
              >下载</el-button
            >
          </el-col>
        </el-row>
        <el-table
          :data="tbList"
          size="small"
          style="width: 100%"
          v-loading="loading"
        >
          <el-table-column align="left" prop="_id" label="序号" width="80">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column
            align="left"
            prop="email"
            label="邮箱"
            min-width="180"
          >
          </el-table-column>
          <el-table-column
            align="left"
            prop="code"
            label="兑换码"
            min-width="150"
          >
            <template slot-scope="scope">
              <span style="color: #165dff">
                {{ scope.row.code }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            align="left"
            prop="exchangeVip"
            label="会员"
            min-width="100"
          >
            <template slot-scope="scope">
              {{
                vipMap[
                  `${scope.row.exchangeVip ?? ""}-${
                    scope.row.exchangeSubVip ?? ""
                  }`
                ]?.name
              }}
            </template>
          </el-table-column>
          <el-table-column
            align="left"
            prop="exchangeSubVip"
            label="会员内容"
            min-width="150"
          >
            <template slot-scope="scope">
              {{
                vipMap[
                  `${scope.row.exchangeVip ?? ""}-${
                    scope.row.exchangeSubVip ?? ""
                  }`
                ]?.content
              }}
            </template>
          </el-table-column>

          <el-table-column
            align="left"
            prop="createdAt"
            label="发送时间"
            min-width="150"
          ></el-table-column>

          <el-table-column
            align="left"
            prop="exchangeTime"
            label="兑换时间"
            min-width="150"
          ></el-table-column>
          <el-table-column align="left" prop="un" label="用户" width="120">
            <template slot-scope="scope">
              <router-link
                :to="{
                  path: '/userDetail',
                  query: {
                    id: scope.row.uid,
                    tabs: 'first',
                  },
                }"
              >
                {{ scope.row.un }}
              </router-link>
            </template>
          </el-table-column>
          <el-table-column align="left" prop="status" label="状态" width="80">
            <template slot-scope="scope">
              {{ statusMap[scope.row.status] }}
            </template>
          </el-table-column>
          <el-table-column
            align="left"
            prop="operator"
            label="操作人"
            width="80"
          >
          </el-table-column>
          <el-table-column
            align="left"
            prop="sendStatus"
            label="发送状态"
            width="80"
          >
            <template slot-scope="scope">
              {{ sendStatusMap[scope.row.sendStatus] }}
            </template>
          </el-table-column>
          <el-table-column
            v-if="$jumpPerm('del_redeem')"
            align="center"
            fixed="right"
            label="操作"
            width="120"
          >
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.status === 1"
                @click="repeal(scope)"
                type="text"
                size="small"
              >
                作废
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="dial-pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[5, 10, 20, 50, 100, 200, 300, 400]"
            :page-size="size"
            layout="->,sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { exportToExcel } from "@/utils/util";
import { Message } from "element-ui";
import {
  redeemList,
  redeemRepeal,
  vipAll,
  redeemEmail,
} from "../../api/userApi";
import { handleResponse } from "../../utils/response";

export default {
  name: "RedeemEmail",
  data() {
    return {
      activeName: "one",
      emails: "",
      vipEmails: [],
      statusMap: {
        1: "未兑换",
        2: "已兑换",
        3: "已作废",
      },
      sendStatusMap: {
        1: "发送成功",
        "-1": "发送失败",
      },
      searchForm: {},
      tbList: [],
      size: 10,
      page: 1,
      total: 0,
      loading: true,
      vipMap: {},
      totalData: { total: 0, ydh: 0, zf: 0, dhl: 0 },
      multipleSelection: [],
      EMAIL_EXP:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    };
  },
  computed: {
    downRedeem() {
      return (
        this.$store.state.userInfo.permissions.includes("downRedeem") ||
        this.$store.getters.isAdmin
      );
    },
    vipNameMap() {
      const m = {};
      Object.keys(this.vipMap).forEach((key) => {
        const v = this.vipMap[key];
        m[v.content] = { ...v, key };
      });
      return m;
    },
  },
  watch: {
    emails(newval) {
      this.vipEmails = newval
        .split("\n")
        .filter(Boolean)
        .map((l, i) => {
          const [email, vipName] = l.split(/[,\s\t]+/);
          let vip = this.vipNameMap[vipName];
          return this.errVip({ key: i + 1, email, vip });
        });
    },
  },
  created() {
    this.init(1, true);
    this.loadVips();
  },
  methods: {
    sendCode() {
      if (this.vipEmails.length && !this.vipEmails.some((e) => !!e.err)) {
        redeemEmail({
          emailExchangeCodes: this.vipEmails.map((v) => ({
            email: v.email,
            vip: v.vip.key,
          })),
        }).then((res) => {
          handleResponse(
            res,
            (data) => {
              this.$message.success("发送成功！明细请到发送记录查看");
              this.emails = "";
            },
            (error) => {
              this.$message.error("发送失败");
            }
          );
        });
      } else {
        this.$message.warning("请输入邮箱、会员并检查数据格式");
      }
    },
    errVip(v) {
      const err = [];
      if (!this.EMAIL_EXP.test(v.email)) {
        err.push("邮箱格式不正确");
      }
      if (!v.vip) {
        err.push("会员内容未设置");
      }
      return { ...v, err: err.join() };
    },
    setVip(vipName) {
      this.vipEmails = this.vipEmails.map((v) => {
        if (this.multipleSelection.some((s) => s.key === v.key)) {
          v.vip = this.vipNameMap[vipName];
          return this.errVip(v);
        }
        return v;
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    async loadRList() {
      const p = this.queryParams();

      const total = this.total;
      let ydh = 0;
      let zf = 0;

      if (p.status) {
        if (p.status === "2") {
          ydh = total;
        } else if (p.status === "3") {
          zf = total;
        }
      } else {
        const ydhRes = await redeemList({
          ...p,
          status: 2,
          page: 1,
          size: 1,
        });

        const zfRes = await redeemList({
          ...p,
          status: 3,
          page: 1,
          size: 1,
        });

        ydh = ydhRes.data?.data?.count ?? 0;
        zf = zfRes.data?.data?.count ?? 0;
      }

      const dhl = total > 0 ? ((ydh / total) * 100).toFixed(2) : 0;

      this.totalData = {
        total,
        ydh,
        zf,
        dhl,
      };
    },
    loadVips() {
      vipAll().then((res) => {
        handleResponse(
          res,
          (data) => {
            this.vipMap = (data.list || [])
              .map((v) => {
                if (v.subVipList?.length) {
                  return v.subVipList.map((s) => ({
                    ...s,
                    _id: v._id,
                    name: v.name,
                    content: s.name,
                  }));
                }
                return [v];
              })
              .flat()
              .reduce((m, n) => {
                m[`${n._id}-${n.type ?? ""}`] = n;
                return m;
              }, {});
          },
          (error) => {}
        );
      });
    },
    queryParams() {
      const { exchangeTime, createdAt, ...q } = this.searchForm;
      return {
        buildMethod: "1",
        ...q,
        createdAt:
          createdAt?.length > 0
            ? createdAt
                .map((n, i) => n + " " + (i == 0 ? "00:00:00" : "23:59:59"))
                .join("~")
            : "",
        exchangeTime:
          exchangeTime?.length > 0
            ? exchangeTime
                .map((n, i) => n + " " + (i == 0 ? "00:00:00" : "23:59:59"))
                .join("~")
            : "",
      };
    },
    download() {
      redeemList({
        ...this.queryParams(),
        page: 1,
        size: 10000,
      }).then((res) => {
        handleResponse(
          res,
          (data) => {
            exportToExcel(
              data.list.map((n, i) => ({
                序号: i + 1,
                邮箱: n.email,
                兑换码: n.code,
                会员:
                  this.vipMap[
                    `${n.exchangeVip ?? ""}-${n.exchangeSubVip ?? ""}`
                  ]?.name || "",
                会员内容:
                  this.vipMap[
                    `${n.exchangeVip ?? ""}-${n.exchangeSubVip ?? ""}`
                  ]?.content || "",
                发送时间: n.createdAt,
                兑换时间: n.exchangeTime,
                用户: n.un ?? "",
                状态: this.statusMap[n.status],
                操作人: n.operator,
                发送状态: this.sendStatusMap[n.sendStatus],
              })),
              "兑换码"
            );
          },
          (error) => {
            this.loading = false;
          }
        );
      });
    },
    repeal(scope) {
      redeemRepeal({ _id: scope.row.id }).then((res) => {
        handleResponse(
          res,
          (data) => {
            Message.success("作废成功");
            scope.row.status = 3;
          },
          (error) => {
            Message.error("作废失败");
          }
        );
      });
    },
    init(page = 1, flag = false) {
      this.page = page;
      this.loading = true;
      redeemList({
        ...this.queryParams(),
        page,
        size: this.size,
      }).then((res) => {
        handleResponse(
          res,
          (data) => {
            this.tbList = data.list;
            this.total = data.count;
            this.loading = false;
            // if (flag) {
            this.loadRList();
            // }
          },
          (error) => {
            this.loading = false;
          }
        );
      });
    },
    handleSizeChange(val) {
      this.size = val;
      this.init();
    },
    handleCurrentChange(val) {
      this.init(val);
    },
    reset() {
      this.searchForm = {};
      this.init();
    },
  },
};
</script>
<style scoped></style>
